// initial state
import * as base from "./base.js";
const squadName = "/admin/api/squad";

const obj = base.setBaseUrl("squad", squadName);
const a = Object.assign(obj);
export default a;
